const cn = {
    protect_free: 'Eureka 技术保护',
    protect_trial: 'Eureka 技术保护',
    protect_commercial_old: 'Eureka 技术保护',
    protect_commercial: 'Eureka 技术保护',
    material_trial: 'Eureka 新材料',
    material_commercial_old: 'Eureka 新材料',
    material_commercial: 'Eureka 新材料',
    material_commercial_rapid_search: 'Eureka 材料速研版',
    air_free: 'Eureka 基础版',
    air_trial: 'Eureka 技术方案',
    air_commercial: 'Eureka 技术方案',
    unlock_skills_trial: 'Eureka 试用版',
    insights_trial: 'Eureka 研发情报',
    insights_commercial: 'Eureka 研发情报',
    air_commercial_professional_edition: 'Eureka 研发专业版',
    air_commercial_professional_edition_trial: 'Eureka 研发专业版',
    air_commercial_navigator_edition: 'Eureka 研发领航版',
    air_commercial_navigator_edition_trial: 'Eureka 研发领航版',
    feishu_trial: 'Eureka 研发专业版（试用）',

    ls_trial: 'Eureka 生物医药 (试用)',
    ls_trial_five: 'Eureka 生物医药',
    ls_commercial: 'Eureka 生物医药',
    ls_commercial_share: 'Eureka 生物医药专业版',
    ls_commercial_share_trial: 'Eureka 生物医药 (试用)',
    ls_trial_hiro: 'Eureka 生物医药百科问答 & 文档精读 (试用)',
    ls_trial_hiro_full: 'Eureka 生物医药百科问答 & 文档精读 (试用)',
    ls_commercial_hiro: 'Eureka 生物医药百科问答 & 文档精读',
    ls_commercial_pharma: 'Eureka 生物医药百科问答 & 文档精读',
    ls_commercial_draft: 'Eureka 马库什权要撰写 ',
    ls_commercial_antibody: 'Eureka 优选抗体推荐',
    ls_commercial_launch: 'Eureka 药物知产报告',
    ls_commercial_agent: 'Eureka 生物医药增强包',

    ip_commercial: 'Eureka 知识产权',
    ip_trial_novelty_drafting: 'Eureka 知识产权',
    ip_trial_infringement: 'Eureka 防侵权检索',
    ip_trial_novelty: 'Eureka 查新检索',
    ip_commercial_specification_cnipa: 'Eureka 专利说明书撰写(CNIPA)',
    ip_commercial_specification_uspto: 'Eureka 专利说明书撰写(USPTO)',
    ip_commercial_specification_epo: 'Eureka 专利说明书撰写(EPO)',
    ip_commercial_design_infringement: 'Eureka 外观防侵权检索',
    ip_commercial_infringement: 'Eureka 防侵权检索',
    ip_commercial_disclosure: 'Eureka 技术交底书撰写',
    ip_commercial_translation: 'Eureka 专利翻译',
    ip_commercial_novelty: 'Eureka 查新检索',
    ip_commercial_novelty_draft: 'Eureka AI查新&撰写',
    ip_commercial_draft: 'Eureka AI撰写',
    ip_plg_free: 'Eureka IP 通用流量(免费版)',

    // 0701 积分套餐
    agent_personal_commercial: 'Eureka 个人付费版',
    ls_commercial_credits: 'Eureka 生命科学',
    ls_trial_credits: 'Eureka 生命科学 (试用)',
    air_commercial_credits: 'Eureka工程创新',
    air_trial_credits: 'Eureka工程创新（试用）',
    ip_searching_commercial_credits: 'Eureka IP 检索',
    ip_searching_trial_credits: 'Eureka IP 检索（试用）',
    ip_drafting_max: 'Eureka IP 撰写 Max',
};

const en = {
    protect_free: 'Eureka Search',
    protect_trial: 'Eureka Search',
    protect_commercial_old: 'Eureka Search',
    protect_commercial: 'Eureka Search',
    material_trial: 'Eureka Materials',
    material_commercial_old: 'Eureka Materials',
    material_commercial: 'Eureka Materials',
    material_commercial_rapid_search: 'Eureka Materials Express',
    air_free: 'Eureka Basic',
    air_trial: 'Eureka Ideas',
    air_commercial: 'Eureka Ideas',
    unlock_skills_trial: 'Eureka Trial',
    insights_trial: 'Eureka Scout',
    insights_commercial: 'Eureka Scout',
    air_commercial_professional_edition: 'Eureka R&D Professional Edition',
    air_commercial_professional_edition_trial: 'Eureka R&D Professional Edition',
    air_commercial_navigator_edition: 'Eureka R&D Pilot Edition',
    air_commercial_navigator_edition_trial: 'Eureka R&D Pilot Edition',
    feishu_trial: 'Eureka Engineering Professional Edition (Trial)',

    ls_trial: 'Eureka Life Sciences (Trial)',
    ls_trial_five: 'Eureka Life Sciences',
    ls_commercial: 'Eureka Life Sciences',
    ls_commercial_share: 'Eureka Life Sciences Professional',
    ls_commercial_share_trial: 'Eureka Life Sciences (Trial)',
    ls_trial_hiro: 'Eureka Life Sciences - PIA & PDA (Trial)',
    ls_trial_hiro_full: 'Eureka Life Sciences - PIA & PDA (Trial)',
    ls_commercial_hiro: 'Eureka Life Sciences - PIA & PDA',
    ls_commercial_pharma: 'Eureka Life Sciences - PIA & PDA',
    ls_commercial_draft: 'Eureka Life Sciences - MCD',
    ls_commercial_antibody: 'Eureka Life Sciences - ATP',
    ls_commercial_launch: 'Eureka Life Sciences - PCIE',
    ls_commercial_agent: 'Eureka Life Sciences Usage Package',

    ip_commercial: 'Eureka IP',
    ip_trial_novelty_drafting: 'Eureka IP',
    ip_trial_infringement: 'Eureka IP - FTO Search',
    ip_trial_novelty: 'Eureka IP - Novelty Search',
    ip_commercial_specification_cnipa: 'Eureka IP - Patent Drafting (CNIPA)',
    ip_commercial_specification_uspto: 'Eureka IP - Patent Drafting (USPTO)',
    ip_commercial_specification_epo: 'Eureka IP - Patent Drafting (EPO)',
    ip_commercial_design_infringement: 'Eureka IP - Design FTO Search',
    ip_commercial_infringement: 'Eureka IP - FTO Search',
    ip_commercial_disclosure: 'Eureka IP - Invention Disclosure',
    ip_commercial_translation: 'Eureka IP - Patent Translation',
    ip_commercial_novelty: 'Eureka IP - Novelty Search',
    ip_commercial_novelty_draft: 'Eureka IP - AI Novelty Search & AI Drafting',
    ip_commercial_draft: 'Eureka IP - AI Drafting',
    ip_plg_free: 'Eureka IP General Traffic (Free)',

    // 0701 积分套餐
    agent_personal_commercial: 'Eureka Pro',
    ls_commercial_credits: 'Eureka LifeSciences',
    ls_trial_credits: 'Eureka LifeSciences (Trial)',
    air_commercial_credits: 'Eureka Engineering',
    air_trial_credits: 'Eureka Engineering (Trial)',
    ip_searching_commercial_credits: 'Eureka IP Searching',
    ip_searching_trial_credits: 'Eureka IP Searching(Trial)',
    ip_drafting_max: 'Eureka IP Drafting Max',
};

const tw = {
    protect_free: 'Eureka 科技保護',
    protect_trial: 'Eureka 科技保護',
    protect_commercial_old: 'Eureka 科技保護',
    protect_commercial: 'Eureka 科技保護',
    material_trial: 'Eureka 新材料',
    material_commercial_old: 'Eureka 新材料',
    material_commercial: 'Eureka 新材料',
    material_commercial_rapid_search: 'Eureka 材料速研版',
    air_free: 'Eureka 基礎版',
    air_trial: 'Eureka 科技方案',
    air_commercial: 'Eureka 科技方案',
    unlock_skills_trial: 'Eureka 試用版',
    insights_trial: 'Eureka 研發情報',
    insights_commercial: 'Eureka 研發情報',
    air_commercial_professional_edition: 'Eureka 研發專業版',
    air_commercial_professional_edition_trial: 'Eureka 研發專業版',
    air_commercial_navigator_edition: 'Eureka 研發領航版',
    air_commercial_navigator_edition_trial: 'Eureka 研發領航版',
    feishu_trial: 'Eureka 研發專業版（試用）',

    ls_trial: 'Eureka 生物醫藥 (試用)',
    ls_trial_five: 'Eureka 生物醫藥',
    ls_commercial: 'Eureka 生物醫藥',
    ls_commercial_share: 'Eureka 生物醫藥專業版',
    ls_commercial_share_trial: 'Eureka 生物醫藥 (試用)',
    ls_trial_hiro: 'Eureka 生物醫藥百科問答 & 文檔精讀 (試用)',
    ls_trial_hiro_full: 'Eureka 生物醫藥百科問答 & 文檔精讀 (試用)',
    ls_commercial_hiro: 'Eureka 生物醫藥百科問答 & 文檔精讀',
    ls_commercial_pharma: 'Eureka 生物醫藥百科問答 & 文檔精讀',
    ls_commercial_draft: 'Eureka 馬庫什權要撰寫 ',
    ls_commercial_antibody: 'Eureka 優選抗體推薦',
    ls_commercial_launch: 'Eureka 藥物知產報告',
    ls_commercial_agent: 'Eureka 生物醫藥增強包',

    ip_commercial: 'Eureka 知識產權',
    ip_trial_novelty_drafting: 'Eureka 知識產權',
    ip_trial_infringement: 'Eureka 防侵權檢索',
    ip_trial_novelty: 'Eureka 查新檢索',
    ip_commercial_specification_cnipa: 'Eureka 專利說明書撰寫(CNIPA)',
    ip_commercial_specification_uspto: 'Eureka 專利說明書撰寫(USPTO)',
    ip_commercial_specification_epo: 'Eureka 專利說明書撰寫(EPO)',
    ip_commercial_design_infringement: 'Eureka 外觀防侵權檢索',
    ip_commercial_infringement: 'Eureka 防侵權檢索',
    ip_commercial_disclosure: 'Eureka 技術交底書撰寫',
    ip_commercial_translation: 'Eureka 專利翻譯',
    ip_commercial_novelty: 'Eureka 查新檢索',
    ip_commercial_novelty_draft: 'Eureka AI查新&撰寫',
    ip_commercial_draft: 'Eureka AI撰寫',
    ip_plg_free: 'Eureka IP 通用流量(免費版)',

    // 0701 积分套餐
    agent_personal_commercial: 'Eureka Pro',
    ls_commercial_credits: 'Eureka 生命科學',
    ls_trial_credits: 'Eureka 生命科學 (試用)',
    air_commercial_credits: 'Eureka 工程創新',
    air_trial_credits: 'Eureka 工程創新（試用）',
    ip_searching_commercial_credits: 'Eureka IP 檢索',
    ip_searching_trial_credits: 'Eureka IP 檢索（試用）',
    ip_drafting_max: 'Eureka IP 撰寫 Max',
};

const jp = {
    protect_free: 'Eureka 計画保護',
    protect_trial: 'Eureka 計画保護',
    protect_commercial_old: 'Eureka 計画保護',
    protect_commercial: 'Eureka 計画保護',
    material_trial: 'Eureka 材料科学',
    material_commercial_old: 'Eureka 材料科学',
    material_commercial: 'Eureka 材料科学',
    material_commercial_rapid_search: 'Eureka 材料クイック研究版',
    air_free: 'Eureka 基礎版',
    air_trial: 'Eureka 研究開発計画',
    air_commercial: 'Eureka 研究開発計画',
    unlock_skills_trial: 'Eureka 体験版',
    insights_trial: 'Eureka Scout',
    insights_commercial: 'Eureka Scout',
    air_commercial_professional_edition: 'Eureka 研究開発プロフェッショナル版',
    air_commercial_professional_edition_trial: 'Eureka 研究開発プロフェッショナル版',
    air_commercial_navigator_edition: 'Eureka 研究開発ナビゲーター版',
    air_commercial_navigator_edition_trial: 'Eureka 研究開発ナビゲーター版',
    feishu_trial: 'Eureka 研究開発プロフェッショナル版（体験版）',

    ls_trial: 'Eureka ライフサイエンス (試用)',
    ls_trial_five: 'Eureka ライフサイエンス',
    ls_commercial: 'Eureka ライフサイエンス',
    ls_commercial_share: 'Eureka ライフサイエンス プロフェッショナル版',
    ls_commercial_share_trial: 'Eureka ライフサイエンス (試用)',
    ls_trial_hiro: 'Eureka ライフサイエンス百科Q&A & 文書精読 (試用)',
    ls_trial_hiro_full: 'Eureka ライフサイエンス百科Q&A & 文書精読 (試用)',
    ls_commercial_hiro: 'Eureka ライフサイエンス百科Q&A & 文書精読',
    ls_commercial_pharma: 'Eureka ライフサイエンス百科Q&A & 文書精読',
    ls_commercial_draft: 'Eureka マーカッシュ権利要件作成',
    ls_commercial_antibody: 'Eureka 最適抗体推薦',
    ls_commercial_launch: 'Eureka 医薬知財レポート',
    ls_commercial_agent: 'Eureka ライフサイエンス 拡張パック',

    ip_commercial: 'Eureka IP',
    ip_trial_novelty_drafting: 'Eureka IP',
    ip_trial_infringement: 'Eureka IP - FTO Search',
    ip_trial_novelty: 'Eureka IP - Novelty Search',
    ip_commercial_specification_cnipa: 'Eureka IP - Patent Drafting (CNIPA)',
    ip_commercial_specification_uspto: 'Eureka IP - Patent Drafting (USPTO)',
    ip_commercial_specification_epo: 'Eureka IP - Patent Drafting (EPO)',
    ip_commercial_design_infringement: 'Eureka IP - Design FTO Search',
    ip_commercial_infringement: 'Eureka IP - FTO Search',
    ip_commercial_disclosure: 'Eureka IP - Invention Disclosure',
    ip_commercial_translation: 'Eureka IP - Patent Translation',
    ip_commercial_novelty: 'Eureka IP - Novelty Search',
    ip_commercial_novelty_draft: 'Eureka IP - AI Novelty Search & AI Drafting',
    ip_commercial_draft: 'Eureka IP - AI Drafting',
    ip_plg_free: 'Eureka IP ユニバーサルトラフィック(無料版)',

    // 0701 积分套餐
    agent_personal_commercial: 'Eureka Pro',
    ls_commercial_credits: 'Eureka LifeSciences',
    ls_trial_credits: 'Eureka LifeSciences (Trial)',
    air_commercial_credits: 'Eureka Engineering',
    air_trial_credits: 'Eureka Engineering (Trial)',
    ip_searching_commercial_credits: 'Eureka IP 検索',
    ip_searching_trial_credits: 'Eureka IP 検索（試用）',
    ip_drafting_max: 'Eureka IP 作成 Max',
};

export {
    cn, en, tw, jp,
};
